module.exports = __webpack_public_path__ + "img/bg2.2935074b.png";